import { render, staticRenderFns } from "./DejaVu.vue?vue&type=template&id=e45a6098&"
import script from "./DejaVu.vue?vue&type=script&lang=js&"
export * from "./DejaVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports